module.exports = __webpack_public_path__ + "img/icon-stats.1427b07d.svg";